import {createFileRoute} from '@tanstack/react-router';

import {AuditLogPage} from '@/modules/admin/pages/AuditLogPage';

export const Route = createFileRoute('/_authenticated/admin/audit-log/')({
  component: AuditLogPage,
});
